import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PostService } from 'src/app/core/services/post.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  templateUrl: './score-dg.component.html',
  styleUrls: ['./score-dg.component.scss']
})
export class ScoreDgComponent implements OnInit {
  data;
  scoreSelecter = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public dialogRef: MatDialogRef<ScoreDgComponent>,
    private userService: UserService,

  ) { }

  ngOnInit(): void {


  }
  saveChanges() {
    this.userService.setScoreForMarketer({
      marketerId: String(this.dialogData.id),
      score: String(this.scoreSelecter)
    }).subscribe(
      res => {
        this.dialogRef.close();
      }
    );
  }
}
